import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";

const Signup = function () {
  const { user } = useContext(AuthContext);
  const URL_SIGNUP = process.env.REACT_APP_URL_USERS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [text, setText] = useState(false);
  const [selectedPlantel, setSelectedPlantel] = useState(process.env.REACT_APP_PLANTELES_GENERAL);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState(process.env.REACT_APP_AREAS_GENERAL);

  useEffect(() => {

  axios
  .get(URL_AREAS, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((res) => {
    const allAreas = res.data;
    setAreas(allAreas);
  })
  .catch((err) => {
    console.log(err);
  });
},[]);

  const handleForm = (event) => {
    event.preventDefault();
    axios
      .post(
       URL_SIGNUP,
        {
          nombre: firstName,
          apellido: lastName,
          email,
          password,
          planteles: selectedPlantel,
          areas: selectedArea,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        clear();
        Swal.fire("Listo", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Algo salio mal",
          text: "No se pudo completar",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  };

  const clear = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPassword("");
    setSelectedPlantel('')
    setSelectedArea('')
  };



  return (
    <>
      <br />
      <br />
        <div className="card container">
          <h3 align="center">Registro de Usuarios</h3>
          <Form className="container" onSubmit={handleForm}>
              <Label>Nombre</Label>
              <Input
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                type="text"
                id="firstName"
                name="inputFirstName"
                placeholder="Nombre"
              />
              <Label>Apellido</Label>
              <Input
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                type="text"
                name="lastName"
                id="inputLastname"
                placeholder="Apellido"
              />
              <Label>Email</Label>
              <Input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                name="email"
                id="exampleEmail"
                placeholder="Email"
              />
              <Label>Contraseña</Label>
              <Input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                name="password"
                id="examplePassword"
                placeholder="Contraseña"
              />
            {user.usuarios_create?(
            <Button type="submit" className="btn btn-success">
            Dar de Alta
          </Button>
          ): (
            <Button type="submit" className="btn btn-success" disabled>
            Dar de Alta
          </Button>
          ) }
            <div>
            <SweetAlert
              show={text}
              title="Creado con Exito"
              onConfirm={() => {
                setText(false);
                window.location.href = "/MenuUsuarios";
              }}
            />
          </div>
          </Form>
      </div>
    </>
  );
};

export default Signup;
